
(function (jQuery) {

  const $gRecaptchaForm = jQuery('.g-recaptcha-form');

  if ($gRecaptchaForm.length) {
    jQuery.getScript({
      url: 'https://www.google.com/recaptcha/api.js',
      cache: true
    })
      .then(() => {
        $gRecaptchaForm.on('submit', function (event) {

          event.preventDefault();
          window.grecaptcha.reset();
          window.grecaptcha.execute();
        });

      });
  }

}(jQuery));